import { procedureManageRoute } from './manage.route';

export const procedureCreateRoute = procedureManageRoute(
  'create/:procedureId?',
  'procedureCreate',
  'Tworzenie procedury',
  [
    { title: 'Nazwa', name: `procedureCreateBase` },
    { title: 'Załączniki', name: `procedureEditAttachments` }
  ]
);
